var $ = require('jquery');
var pathExtract = require('../core/path-extract');
var url = require('../core/url');
var ajax = require('../core/ajax');
var templateCache = require('./template-cache');

//解析 router
function parseRouter(router,path) {
    var ret = {};
    if(!path){
        return ret;
    }
    var page = router[path];
    if(page){
        ret.page = page;
        return ret;
    }
    $.each(router,function (key,value) {
        var p = pathExtract(key, path);
        if(p){
            ret.params = p;
            ret.page  = value;
            return false;
        }
    });
    return ret;
}

/**
 * 根据路径渲染页面
 * @param config
 * @example
 *
      //预留版本处理接口
    function __uri(uri) {
        return uri;
    }
    go({
        use: require,
        container:$('#container'),
        components:{
            name:{
                templateUrl: __uri('/component.html'),
                loader: {
                    preload: [
                        'css!' + __uri('/component.css'),
                        'datatables.net'
                    ],
                    main: __uri('/component.js')
                },
                resource: {
                    res:__uri('/res.tpl')
                }
            }
        },
        router: {
            '/path': {// 还支持 '/path/:id' 动态路径,当匹配 '/path/1' 此时入口函数有 options.params.id 等于 1
                title:'标题',
                templateUrl: __uri('/page.html'),
                noLogout: true, // 不需要登出功能：true：不需要，false：需要
                loader: {
                    preload: [
                        'css!' + __uri('/page.css'),
                        'datatables.net'
                    ],
                    main: __uri('/page.js')
                },
                resource: {
                    res:__uri('/res.tpl')
                },
                components:{...}
            },
        }
    });
 *
 */
function go(config) {
    var _use = config.use;
    var _container = $(config.container);
    var _router = config.router;
    var _components = config.components;
    var _params;
    var _p = url('?_p');
    var _path = url('path') || '/'; // 兼容首页无明显路由的情况
    var _page;
    var temp = parseRouter(_router,_p);
    if(temp.page){
        _path = _p;
        _page = temp.page;
        _params = temp.params;
    }else{
        temp = parseRouter(_router,_path);
        _page = temp.page;
        _params = temp.params;
    }


    function controller(options) {
        var loader = options.loader;
        var childrenOpt = options.childrenOpt;
        var components = $.extend({},childrenOpt && childrenOpt.components,options.components);

        function component(name) {
            var ret = null;
            if(components && components[name]){
                ret = dealPage(components[name],{components:components});
            }else if(_components && _components[name]){
                ret = dealPage(_components[name],{components:components});
            }else{
                throw new Error(name + '组件没有找到');
            }
            return Promise.resolve(ret);
        }
        return new Promise(function (resolve, reject) {
            var ret = null;
            if(loader.main){
                _use(loader.preload || [], function () {
                    _use([loader.main], function (view) {
                        var type = $.type(view);
                        // main 函数入口选项
                        var initOption = {
                            container: _container,//容器,jquery对象
                            template: options.template,//模版
                            resource : options.resource,//资源 url
                            path:_path,//url 路径
                            /*
                             //路径查询查询
                             pathExtract('/user/:username/post/:id', '/user/egoist/post/1')
                             //=> params:
                             {
                                 username: 'egoist',
                                 id: '1'
                             }
                            * */
                            params:_params || null,//url path 查询查询对象
                            query:url('?') || null,//url search 查询对象
                            hash:url('#') || null,//url hash 查询对象
                            component:component//加载组件方法
                        };

                        if(type === 'function'){
                            if (!view._initMod) {
                                view._initMod = view(initOption);
                            }
                            resolve(view._initMod);
                        }else{
                            resolve(view);
                        }
                    });
                });
            }else {
                resolve(ret);
            }
        });
    }
    function dealPage(page,childrenOpt) {
        var opts;
        var template;
        var ret = null;
        var $welcome = $('.welcome');
        if (page) {
            opts = {
                childrenOpt:childrenOpt,
                components:page.components,
                template: page.template||'',
                loader: page.loader,
                resource: page.resource
            };
            if(!childrenOpt && page.title){
                document.title = page.title;
            }

            // noLogout：不需要登出功能：true->不需要，false->需要
            !page.noLogout && $welcome.removeClass('hidden');

            if(opts.template){
                ret = controller(opts);
            }else if(page.templateUrl){
                template = templateCache.get(page.templateUrl);
                if(template && $.type(template.then)==='function'){
                    ret = Promise.resolve(template).then(function (template) {
                        return controller($.extend(opts,{
                            template: template
                        }));
                    });
                }else{
                    ret = controller($.extend(opts,{
                        template: template
                    }));
                }
            }else{
                ret = controller(opts);
            }
        }

        return Promise.resolve(ret);
    }

    dealPage(_page);
}

module.exports = {
    go:go
};


//////////////////
// WEBPACK FOOTER
// ./src/components/router.js
// module id = 190
// module chunks = 0